import { render, staticRenderFns } from "./ReservationsList.vue?vue&type=template&id=7ad88724&"
import script from "./ReservationsList.vue?vue&type=script&lang=js&"
export * from "./ReservationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports